const URL = {
  COLLECTION_LIST: 'collection/filter',
  COLLECTION_UPDATE: 'collection/update',
  COLLECTION_DELETE: 'collection/delete',
  COLLECTION_GET: 'collection/{id}',
  COLLECTION_CREATE: 'CourseCollection/Create',
  COLLECTION_COURSE_LIST: 'collection/{collectionId}/courses',
  COLLECTION_MEMBERS_LIST: 'collection/{id}/members/filter',
}

export default URL
